export default function RAGBadge({ status, size = "md" }) {
  const map = {
    Green: { label: "On Track", cls: "bg-green-100 text-green-700" },
    Amber: { label: "At Risk", cls: "bg-amber-100 text-amber-700" },
    Red: { label: "Critical", cls: "bg-red-100 text-red-700" },
    green: { label: "On Track", cls: "bg-green-100 text-green-700" },
    amber: { label: "At Risk", cls: "bg-amber-100 text-amber-700" },
    red: { label: "Critical", cls: "bg-red-100 text-red-700" },
    on_track: { label: "On Track", cls: "bg-green-100 text-green-700" },
    at_risk: { label: "At Risk", cls: "bg-amber-100 text-amber-700" },
    critical: { label: "Critical", cls: "bg-red-100 text-red-700" },
  };
  const { label, cls } = map[status] || { label: status, cls: "bg-slate-100 text-slate-600" };
  const sz = size === "sm" ? "text-xs px-2 py-0.5" : "text-xs px-2.5 py-1";
  return <span className={`inline-flex items-center gap-1 rounded-full font-medium ${sz} ${cls}`}>{label}</span>;
}

export function RAGDot({ status }) {
  const map = { Green: "bg-green-500", Amber: "bg-amber-400", Red: "bg-red-500",
                green: "bg-green-500", amber: "bg-amber-400", red: "bg-red-500" };
  return <span className={`w-2 h-2 rounded-full inline-block flex-shrink-0 ${map[status] || "bg-slate-300"}`} />;
}
